module.exports = __webpack_public_path__ + "static/media/24UHCHR4.69d57c83.jpg";